// extracted by mini-css-extract-plugin
export default {"empty-search-results":"dpaYG"};